import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Alert, Button,
  Drawer, Popover,
} from 'antd';
import './style.scss';
import CustomerActions from '@Actions/customerActions';
import SellerActions from '@Actions/sellerActions';
import CustomerForm from '@Components/Sales/Customer/CustomerHome/CreateCustomer/CustomerForm';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import { CountryCodes } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import ViewCustomFields from '@Components/Common/CustomField/ViewCustomFields';
import SelectCustomer from '@Components/Common/SelectCustomer';
import { EditOutlined } from '@ant-design/icons';
import CustomerAddresses from './CustomerAddresses';
import UpdateTallyCustomer from '../../../../Common/UpdateTallyLedger/UpdateTallyCustomer';

/**
 *
 */
class CustomerProducts extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      isDrawerOpen: false,
    };
  }

  /**
   *
   */
  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      getCustomerByIdLoading, selectedCustomer, getCustomerById, user, match, MONEY,
    } = this.props;
    const { showEditCustomerDrawer, isDrawerOpen } = this.state;
    return (
      <Fragment>
        <div className="customer-overview__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-8 ant-col-xs-24">
              <div className="customer-overview__left">
                <div className="customer-overview__left-header">
                  <div className="customer-overview__left-heading">
                    CUSTOMER INFORMATION
                  </div>
                  {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.UPDATE, user) && (
                    <div
                      className="customer-overview__left-sub"
                      onClick={() => this.setState({ showEditCustomerDrawer: true })}
                    >
                      Edit
                    </div>
                  )}
                </div>

                <div className=" customer-overview__left__unit-info">
                  {!getCustomerByIdLoading
                    ? (
                      <React.Fragment>
                        {selectedCustomer?.customer_info?.contact_person_name
                          && (
                            <div className="unit-info-row">
                              <div className="unit-info-row__label">
                                Contact Person
                              </div>
                              <div className="unit-info-row__value">
                                {selectedCustomer?.customer_info?.contact_person_name}
                              </div>
                            </div>
                          )}
                        <div className="unit-info-row">
                          <div className="unit-info-row__label">
                            Customer Type
                          </div>
                          <div className="unit-info-row__value">
                            {selectedCustomer?.customer_info?.customer_type}
                          </div>
                        </div>
                        <div className="unit-info-row">
                          <div className="unit-info-row__label">
                            GST Treatment Type
                          </div>
                          <div className="unit-info-row__value">
                            {selectedCustomer?.customer_info?.gst_treatment?.replaceAll('_', ' ')?.toProperCase()}
                          </div>
                        </div>
                        <div className="unit-info-row">
                          <div className="unit-info-row__label">
                            Phone
                          </div>
                          <div className="unit-info-row__value">
                            {selectedCustomer?.customer_info?.phone_number ? (`${CountryCodes?.find((code) => code?.dial_code == selectedCustomer?.customer_info?.dial_code)?.flag || ''} +${selectedCustomer?.customer_info?.dial_code || ''} ${selectedCustomer?.customer_info?.phone_number}`) : '-'}
                          </div>
                        </div>
                        <div className="unit-info-row">
                          <div className="unit-info-row__label">
                            Email
                          </div>
                          <div className="unit-info-row__value">
                            {selectedCustomer?.customer_info?.email_address || '-'}
                          </div>
                        </div>
                        <div className="unit-info-row">
                          <div className="unit-info-row__label">
                            Currency
                          </div>
                          <div className="unit-info-row__value">
                            {`${selectedCustomer?.currency_info?.currency_code}(${selectedCustomer?.currency_info?.currency_symbol})`}
                          </div>
                        </div>
                        {selectedCustomer?.customer_info?.gst_number
                          && (
                            <div className="unit-info-row">
                              <div className="unit-info-row__label">
                                GST Number
                              </div>
                              <div className="unit-info-row__value">
                                {selectedCustomer?.customer_info?.gst_number}
                              </div>
                            </div>
                          )}
                        {selectedCustomer?.customer_info?.account_manager_info?.account_manager_id
                          && (
                            <div className="unit-info-row">
                              <div className="unit-info-row__label">
                                Sales Manager
                              </div>
                              <div className="unit-info-row__value">
                                {`${selectedCustomer?.customer_info?.account_manager_info?.first_name} ${selectedCustomer?.customer_info?.account_manager_info?.last_name}`}
                              </div>
                            </div>
                          )}
                        {selectedCustomer?.customer_info?.shopify_customer_id
                          && (
                            <div className="unit-info-row">
                              <div className="unit-info-row__label">
                                Shopify ID
                              </div>
                              <div className="unit-info-row__value">
                                <a href={`https://admin.shopify.com/store/${selectedCustomer?.customer_info?.shopify_shop_name?.split('.')?.[0]}/customers/${selectedCustomer?.customer_info?.shopify_customer_id}`} target="_blank" rel="noreferrer">
                                  {selectedCustomer?.customer_info?.shopify_customer_id}
                                </a>
                              </div>
                            </div>
                          )}
                        {user?.tenant_info?.it_id && (

                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Tally Customer Name
                            </div>
                            <div className="unit-info-row__value">
                              <div style={{ display: 'flex', marginLeft: '3px', alignItems: 'center' }}>
                                <div className="unit-info__header-title">
                                  {selectedCustomer?.tally_customers?.[0]?.customer_name}
                                </div>
                                <div>
                                  <div
                                    className="roundIconButton"
                                    onClick={() => {
                                      this.setState({ isDrawerOpen: true });
                                    }}
                                  >
                                    <EditOutlined />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <ViewCustomFields customFields={selectedCustomer?.custom_fields} wrapperClass="unit-info-row" labelClass="unit-info-row__label" valueClass="unit-info-row__value" />
                        {selectedCustomer?.customer_info?.seller_info && (
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Linked Vendor
                            </div>
                            <div className="unit-info-row__value">
                              <Link
                                to={`/vendors/view/${selectedCustomer?.customer_info?.seller_info?.seller_id}`}
                                target="_blank"
                              >
                                {selectedCustomer?.customer_info?.seller_info?.seller_name}
                              </Link>
                            </div>
                          </div>
                        )}
                      </React.Fragment>
                    )

                    : (
                      <React.Fragment>
                        {[1, 2, 3, 4]?.map((item) => (
                          <div key={item} className="customer-overview__loader">
                            <div className="loadingBlock loader-line" />
                          </div>
                        ))}

                      </React.Fragment>
                    )}

                </div>
              </div>
            </div>
            <div className="ant-col-md-8 ant-col-xs-24">
              <CustomerAddresses />
            </div>
            <div className="ant-col-md-8 ant-col-xs-24">
              <div className="customer-overview__metrics-wrapper">
                <div className="customer-overview__metric">
                  <H3Text text="Receivables" className="customer-overview__metric-label" />
                  <H3Text text={MONEY(Number(selectedCustomer?.outgoing_payable || 0))} className="customer-overview__metric-value" />
                </div>
                <div className="customer-overview__metric">
                  <H3Text text="Unused Credits" className="customer-overview__metric-label" />
                  <H3Text text={MONEY(Number(selectedCustomer?.unused_credits || 0))} className="customer-overview__metric-value" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Drawer
          open={showEditCustomerDrawer}
          onClose={() => this.setState({ showEditCustomerDrawer: false })}
          width="720px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '680px' }}>
              <H3Text text="Update Customer Information" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showEditCustomerDrawer: false })} />
            </div>
          </div>
          <CustomerForm
            selectedCustomer={selectedCustomer}
            callback={() => {
              getCustomerById(match?.params?.customerId, user?.tenant_info?.tenant_id);
              this.setState({ showEditCustomerDrawer: false });
            }}
            isUpdate={true}
          />
        </Drawer>
        <Drawer
          open={isDrawerOpen}
          onClose={() => this.setState({ isDrawerOpen: false })}
          width="720px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '680px' }}>
              <H3Text text="Update Tally Customer" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ isDrawerOpen: false })} />
            </div>
          </div>
          <UpdateTallyCustomer
            data={Array.isArray(selectedCustomer) ? selectedCustomer : [selectedCustomer]}
            callback={() => {
              getCustomerById(match?.params?.customerId, user?.tenant_info?.tenant_id);
              this.setState({ isDrawerOpen: false });
            }}
          />
        </Drawer>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  SellerReducers, UserReducers, CustomerReducers,
}) => ({
  getCustomerByIdLoading: CustomerReducers.getCustomerByIdLoading,
  selectedCustomer: CustomerReducers.selectedCustomer,
  updateSellerOffersLoading: CustomerReducers.updateSellerOffersLoading,
  pincodeCity: SellerReducers.pincodeCity,
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomerById: (customerId, tenantId) => dispatch(CustomerActions.getCustomerById(customerId, tenantId)),
  updateSeller: (payload) => dispatch(CustomerActions.updateSeller(payload, '')),
  // updateSellerOffers: (payload, callback) => dispatch(CustomerActions.updateSellerOffers(payload, callback)),
  // getSellerOffersById: (customerId, page) => dispatch(CustomerActions.getSellerOffersById(customerId, page)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  // getSellerProducts: (tenantId, sellerId, productName, page, limit) => dispatch(ProductActions.getSellerProducts(tenantId, sellerId, productName, page, limit)),
});

CustomerProducts.propTypes = {
  user: PropTypes.any,
  match: PropTypes.any,
  getCustomerById: PropTypes.func,
  selectedCustomer: PropTypes.any,
  getCustomerByIdLoading: PropTypes.bool,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomerProducts));
